module.exports = __webpack_public_path__ + "static/img/site_22.5624e11d.5624e11d.png";